<div class="top-nav">

  @if (review?.stage === ReviewStage.AwaitingFeedbackApprovalByQualityAssurer) {
    <button (click)="exit({reviewView:2})"
      aria-label="Back" class="btn btn-back">
      <i class="fa fa-arrow-left"></i>
      <span> {{stage | caseSplit}}</span>
    </button>
  }
  @if (review?.stage === ReviewStage.QualityAssuranceCompleted) {
    <button (click)="exit({reviewView:3})"
      aria-label="Back" class="btn btn-back">
      <i class="fa fa-arrow-left"></i>
      <span> {{stage | caseSplit}}</span>
    </button>
  }
  @if (review?.stage === ReviewStage.CoreCriteriaNotMet) {
    <button (click)="exit({reviewView:5})" aria-label="Back"
      class="btn btn-back">
      <i class="fa fa-arrow-left"></i>
      <span> {{stage | caseSplit}}</span>
    </button>
  }
  @if (review?.stage === ReviewStage.FeedbackSent) {
    <button (click)="exit({reviewView:6})" aria-label="Back"
      class="btn btn-back">
      <i class="fa fa-arrow-left"></i>
      <span> {{stage | caseSplit}}</span>
    </button>
  }
  <div style="flex-grow: 1">

  </div>
  <div>Review: {{review?.title}} | {{role}}</div>
</div>

<app-banner [loading]="loading" [info]="true" heading="Review" [subHeading]="subHeading">

  @if (!loading) {
    <div class="toolbar-content fadein">
      <button class="btn" [class.active]="assigning" (click)="assigning=true">
        <i class="fa fa-user"></i>
        <app-review-assign [item]="review" (selected)="assigning = !!$event" [selecting]="assigning"></app-review-assign>
      </button>
      <button class="btn no-focus" (click)="toggleChat()" [class.open]="chatVisible">
        <i class="fa fa-comments"></i>
        discussion
      </button>
      <app-carousel-nav [items]="items" label="entries" [selectedIndex]="selectedIndex"
        (onIndexSelected)="selectedIndex = $event.index">
      </app-carousel-nav>
      @if (review?.isFeedbackEditable) {
        <button class="btn no-focus" (click)="accept()">
          @if (!saving && !approving) {
            @if (!review?.hasEdits) {
              <i class="fa fa-thumbs-up"></i>
            }
            @if (review?.hasEdits) {
              <i class="fa fa-save"></i>
            }
            @if (!review?.hasEdits) {
              <span>approve</span>
              } @if (review?.hasEdits) {
              <span>save changes</span>
            }
          }
          @if (saving || approving) {
            <i>
              <app-spinner [light]="true" diameter="40"></app-spinner>
            </i>
            @if (saving) {
              <span>saving...</span>
            }
            @if (approving) {
              <span>approving...</span>
            }
          }
        </button>
        <button [disabled]="review.hasEdits || currentUserIsFeedbackAuthor" class="btn no-focus"
          (click)="togglePanel('reject')">
          <i class="fa fa-thumbs-down"></i>
          reject
        </button>
      }
      <button class="btn no-focus" (click)="togglePanel('excludedFromPublish')">
        <i class="fa" [class.fa-check]="!review?.excludedFromPublish" [class.fa-close]="review?.excludedFromPublish"></i>
        publish
      </button>
    </div>
  }

</app-banner>
<app-collapsible [trigger]="showRejection">
  <div class="dropdown-panel important">
    <div style="display:flex; align-items: top;">

      <div style="flex-grow:1">
        @if (!isQAManager) {
          <h4>Feedback not approved</h4>
          <p class="intro-text">
            Your feedback was not approved by the QA manager for the following reason:
          </p>
          <blockquote class="blockquote">
            {{rejection?.feedbackReviewDecisionReason}}
          </blockquote>
        } @else {
          <h4>Feedback not approved</h4>
          <p class="intro-text">
            You rejected the QA's feedback for the following reason:
          </p>
          <blockquote class="blockquote">
            {{rejection?.feedbackReviewDecisionReason}}
          </blockquote>
        }


      </div>
      <div>
        <button style="background:transparent; color: white !important; border: 4px solid white !important;"
        class="mt-4 btn btn-lg btn-block btn-primary" (click)="showRejection=false">OK</button>
      </div>
    </div>



  </div>
</app-collapsible>
<app-collapsible [trigger]="panel==='reject'">
  <div class="dropdown-panel reject-feedback">

    <h4>
      <span>Reject feedback</span>
      <button (click)="panel=undefined" class="btn-default btn-close"><i class="fa fa-close"></i></button>
    </h4>

    <div class="form-group">
      <label>Why are you rejecting this feedback?</label>
      <textarea #rejectionReasonRef class="form-control" [(ngModel)]="rejectionReason"></textarea>
    </div>

    <button (click)="reject()" [disabled]="rejecting || !rejectionReason" class="mt-4 btn btn-lg btn-block btn-primary">
      @if (!rejecting) {
        <span>
          Reject feedback
        </span>
      }
      @if (rejecting) {
        <span style="display:flex;align-items:center">
          <div style="flex-grow:1"></div>
          <app-spinner [tiny]="true" [light]="true"></app-spinner>&nbsp;&nbsp;Sending back...
          <div style="flex-grow:1"></div>
        </span>
      }

    </button>

  </div>
</app-collapsible>

<app-collapsible [trigger]="panel==='excludedFromPublish'">
  <div class="dropdown-panel reject-feedback">

    <h4>
      <span>Include in next publish ?</span>
      <button (click)="panel=undefined" class="btn-default btn-close"><i class="fa fa-close"></i></button>
    </h4>

    <div class="form-group">


      <mat-radio-group [(ngModel)]="shouldexcludedFromPublish">
        <mat-radio-button [value]="false">Yes - include in next publish</mat-radio-button>
        <mat-radio-button [value]="true">No - exclude from next publish</mat-radio-button>
      </mat-radio-group>


    </div>

    <button (click)="setexcludedFromPublish(shouldexcludedFromPublish)"
      [disabled]="excluding || shouldexcludedFromPublish === review?.excludedFromPublish"
      class="mt-4 btn btn-lg btn-block btn-primary">
      @if (!excluding) {
        <span>
          @if (shouldexcludedFromPublish) {
            <span>Exclude from next publish</span>
          }
          @if (!shouldexcludedFromPublish) {
            <span>Include in next publish</span>
          }
        </span>
      }
      @if (excluding) {
        <span style="display:flex;align-items:center">
          <div style="flex-grow:1"></div>
          <app-spinner [tiny]="true" [light]="true"></app-spinner>&nbsp;&nbsp;Updating...
          <div style="flex-grow:1"></div>
        </span>
      }

    </button>

  </div>
</app-collapsible>


<div class="feedback">
  @if (review) {
    <div class="fadein">
      <div class="messaging-container slide" style="max-width:400px" [style.transform]="'translateX('+chatOffset+'px)'"
        [style.webkitTransform]="'translateX('+chatOffset+'px)'">
        <app-discussion [review]="review" [isOpen]="!chatOffset"></app-discussion>
      </div>
      <div class="row content spread" style="padding-bottom:0">
        <div class="col-md-6 left-col fadein">
          <app-carousel [items]="items" [$item]="itemTemplate" [$prev]="prevTemplate" [$next]="nextTemplate"
            [selectedIndex]="selectedIndex" (onSelectedItem)="selectedIndex = $event.index">
          </app-carousel>
          <ng-template let-item let-i="index" #itemTemplate>
            <div class="template-container">
              <section style="margin-bottom: 40px;">
                <app-cpd-entry [cpdEntry]="item" [typeVisible]="false" [annotationsVisible]="true"></app-cpd-entry>
              </section>
            </div>
          </ng-template>
        </div>
        <div class="col-md-6 right-col">
          @if (review.feedbacks && review.feedbacks.length > 1) {
            <section>
              <label>Feedback version</label>
              <mat-select name="feedbackSelection" class="form-control" placeholder="Select feedback version..."
                [(ngModel)]="selectedFeedback">
                @for (item of review.feedbacks; track item; let i = $index) {
                  <mat-option [class.current-feedback]="item===review.feedback"
                    [value]="item">{{ review.feedbacks.length - i }}. {{
                    ReviewerRole[item.author.reviewerRole] | caseSplit }}
                  </mat-option>
                }
              </mat-select>
            </section>
          }
          <section class="feedback-sections-container">
            @if (selectedFeedback===review.feedback) {
              <app-feedback-sections [review]="review"
              (onSelected)="onSelectedSection($event)"></app-feedback-sections>
            }
            @if (selectedFeedback && selectedFeedback!==review.feedback) {
              <app-feedback-sections-readonly
                [review]="review" [feedback]="selectedFeedback" (onSelected)="onSelectedSection($event)">
              </app-feedback-sections-readonly>
            }
          </section>
        </div>
      </div>
    </div>
  }
</div>